<template>
	<EventLayout :event="event" :subtitle="stage.title" :return-url="route('events.stages.survey.index', event.id)" :return-label="trans('events.stages.survey.title')">
		<template #actions>
			<PrimaryButton :color="Color.Green" @click.stop="update">
				<i class="fa-solid fa-save mr-2"/>
				{{ trans('general.save') }}
			</PrimaryButton>
		</template>
		<EditStage :stage="stage"/>
	</EventLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {defineProps, type Ref, ref} from 'vue'
import type {Event} from '@/Types/Events/Event'
import EventLayout from '@/Layouts/EventLayout.vue'
import EditStage from '@/Components/Events/Stages/EditStage.vue'
import {type RaffleStage} from '@/Types/Events/Stages/RaffleStage'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'

const props = defineProps<{
	event:Event,
	stage:RaffleStage,
}>()

const event:Ref<Event> = ref(props.event)
const working:Ref<boolean> = ref(false)
const stage:Ref<RaffleStage> = ref(props.stage)

function update():void{
	if(!working.value){
		working.value = true
		showInfo(trans('general.updating'))
		axios.patch(route('events.stages.raffle.update', {event: event.value.id, stage: stage.value.id}), stage.value).then(() => {
			showSuccess(trans('general.updated'))
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>
